import { UUID } from "@bitory-gmbh/nidavellir";
import { Dialog, DialogContent } from "@/shared/components/ui/dialog";
import {
  CommonDialogFooter,
  CommonDialogHeader,
  CommonDialogTrigger,
} from "@/shared/components/dialog/dialog-common";
import { Trash2 } from "lucide-react";
import t from "@/lang/lang";
import { RTKQueryErrorAlert } from "@/shared/components/errors/rtk-query-error-alert";
import { useRelationshipsRelationshipDeleteCommitmentMutation } from "@/services/backend/relationships/api/service";
import { useEffect, useState } from "react";
import { toast } from "sonner";
import { useNavigate } from "react-router";
import { Relationship } from "@/services/backend/relationships/types/relationship";

export function DeleteCommitmentDialog({
  relationship,
  commitmentId,
}: {
  relationship: Relationship;
  commitmentId: UUID;
}) {
  const [open, setOpen] = useState(false);
  const [deleteCommitment, { isLoading, error, isSuccess, reset }] =
    useRelationshipsRelationshipDeleteCommitmentMutation();

  const navigate = useNavigate();

  useEffect(() => {
    if (isSuccess) {
      reset();
      toast.success(t("Sollstellung gelöscht"));
      setOpen(false);
      navigate(
        `/customers/${relationship.customerId}/relationships/${relationship.id}`,
      );
    }
  }, [isSuccess, navigate, relationship.customerId, relationship.id, reset]);

  const doDelete = () => {
    if (isLoading) {
      return;
    }

    deleteCommitment({ id: relationship.id, commitmentId });
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <CommonDialogTrigger icon={Trash2} label="" variant="destructive" />
      <DialogContent>
        <CommonDialogHeader
          title={t("Sollstellung löschen?")}
          description={t(
            "Es wird nur die Sollstellung gelöscht. Die Serie (sofern eine existiert) bleibt unberührt.",
          )}
        />
        <RTKQueryErrorAlert error={error} />
        <CommonDialogFooter
          isLoading={isLoading}
          onClickAction={doDelete}
          destructive
        />
      </DialogContent>
    </Dialog>
  );
}
